<template>
	<div class="page">
		<el-image src="https://file.aavisa.com/browser-upload-file/cf44dc43-edb0-4770-ba70-6fe66232ff1e.jpg" fit="fill"
			style="width: 100%;"></el-image>
		<div class="box">
			
			<div class="title">
				<p>签证须知</p>
			</div>
			
			<div class="tt">
				<p>一、虎翼掌上签为客户所提供的所有签证服务类别,均属于协助办理性质,您的签证(入境)申请是否成功,完全由该国的签证官(出入境管理机构)根据您递交的申请材料1独立判断,本公司无法以任何方式的干预或交涉;通常情况下,本公司都不承担由签证申请结果而导致被追溯任何赔偿的责任和义务;</p>
				<p>二、有关签证资料上公布的签证有效期和停留期，仅供参考而非任何法定承诺，一切均以签证官（出入境管理机构）签发的签证内容为唯一依据;</p>				
				<p>三、”工作日"、"申请时间"为使馆签发签证时正常情况下的处理时间;若遇特殊原因如政治干涉、假期、使馆内部人员调整、签证打印机故障、打印纸缺失等，则可能会产生延迟出签的情况;本网相关的处理时间信息仅供参考,非法定承诺;请您待拿到签证及护照后再出机票或与酒店确认付款,避免不必要的损失,虎翼掌上签证不承担签证以外其它费用;</p>
				<p>四、资料的真实性是使领馆审核的最关键的因素之一,请申请人确保提供真实的申请资料。</p>
			</div>						
			
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		created() {

		},
		methods: {
			
		}
	}
</script>

<style lang='less' scoped>
	.page {
		text-align: left;
		background-color: #fff;
		.box {
			overflow: hidden;
			width: 75rem;
			height: 49.375rem;
			margin: 0rem auto 0rem;
			
		}

		.title {
			color: #333333;
			font-size: 2rem;
			text-align: center;
			font-weight: 600;
			margin-top: 4.625rem;
			margin-bottom: 3.375rem;
		}

		.tt {
			padding: 0 3.125rem;
			margin-bottom: 1.25rem;

			&>p {
				margin-bottom: 2.275rem;
				margin-top: 0;
				line-height: 2.2rem;
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/visanotice/visanotice.vue